import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // месячный вид
import timeGridPlugin from "@fullcalendar/timegrid"; // дневной/недельный вид
import interactionPlugin from "@fullcalendar/interaction"; // drag & drop

interface PlannerItem {
  key: string;
  processStep: string;
  purchaseOrder: string;
  customer: string;
  startDate: string;
  finishDate: string;
  status: string;
}

interface PlannerCalendarProps {
  data: PlannerItem[];
}

const PlannerCalendar: React.FC<PlannerCalendarProps> = ({ data }) => {
  const events = data.map((item) => ({
    id: item.key,
    title: `Order ${item.purchaseOrder} – ${item.customer}`,
    start: item.startDate,
    end: item.finishDate,
    color: "#4285F4",
  }));

  return (
    <div style={{ padding: 20 }}>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        events={events}
        editable
        selectable
        nowIndicator
        height="auto"
      />
    </div>
  );
};

export default PlannerCalendar;
